import React, { lazy } from 'react';
import { Button } from '../ui/Button';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Diego',
    video: 'https://cdn.magicpatterns.com/uploads/fRrBVgiLXiKzzJQJvS9Hpr/diego.mp4',
    highlight: 'De trabajar en un gimnasio y ganar $200, a generar $1500 todos los meses editando videos'
  }, {
    name: 'Dante',
    video: 'https://cdn.magicpatterns.com/uploads/ezMvLA3xxszfqMSznjd4kh/dante.mp4',
    highlight: 'Editaba sin criterio, se formó con una estrategia clara y logró posicionarse en una gran Agencia de Marketing como Lead Editor de Ads'
  }, {
    name: 'Franco',
    video: 'https://cdn.magicpatterns.com/uploads/sxuEcmiNLgSLpAuR7EvFpV/franco.mp4',
    highlight: 'Aprendió a editar como base de sus habilidades, logró desarrollar un servicio especializado de contenido, y trabajar con Agencias Inmobiliarias de Miami, generando $3000 al mes'
  }, {
    name: 'Tiziano',
    video: 'https://cdn.magicpatterns.com/uploads/9TwHfYJh2pQbFhLF2cB8zS/tizi.mp4',
    highlight: 'Empezó a editar con mi metodología mientras iba a la escuela secundaria, hoy sigue editando tiempo completo, dirigiendo equipos de editores, generando $2000 al mes y puede seguir estudiando su carrera universitaria'
  }, {
    name: 'Gimenez',
    video: 'https://cdn.magicpatterns.com/uploads/78uXctVNUNhwJpXqpHjWbu/gimenez.mp4',
    highlight: 'Aprendio a editar desde cero, crear videos con intención y objetivo, que lo permitio posicionarse en una empresa de contenido de estados unidos gracias a mi bolsa de trabajo'
  }];
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-170">
      <div className="max-w-6xl mx-auto" data-id="element-171">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4" data-id="element-172">
          ¿Querés ser el próximo{' '}
          <span className="text-blue-400" data-id="element-173">caso de éxito</span> como ellos?
        </h2>
        <p className="text-slate-400 text-center text-lg mb-14 max-w-2xl mx-auto" data-id="element-174">
          Ellos empezaron desde cero y hoy generan ingresos reales editando
          videos. Escuchá sus historias.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-175">
          {testimonials.map((testimonial, index) => <div key={index} className="group bg-slate-800/50 rounded-2xl border border-slate-700/50 overflow-hidden flex flex-col shadow-xl hover:shadow-blue-900/20 hover:border-blue-500/30 transition-all duration-300" data-id="element-176">
              {/* Video */}
              <div className="relative w-full aspect-[9/16] bg-slate-950 overflow-hidden" data-id="element-177">
                <div className="absolute top-3 left-3 z-10 bg-blue-600/90 backdrop-blur-sm text-white text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-lg" data-id="element-178">
                  <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-179">
                    <polyline points="20 6 9 17 4 12" data-id="element-180"></polyline>
                  </svg>
                  Alumno
                </div>
                <video src={testimonial.video} className="w-full h-full object-cover" controls preload="metadata" playsInline data-id="element-181" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent pointer-events-none opacity-60" data-id="element-182" />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col items-center justify-center bg-gradient-to-b from-slate-800 to-slate-900 flex-grow relative" data-id="element-183">
                <div className="absolute -top-4 bg-slate-800 border border-slate-700 rounded-full px-3 py-1 flex text-yellow-400 text-xs shadow-lg" data-id="element-184">
                  {'★★★★★'}
                </div>
                <h3 className="text-lg font-bold text-white mt-2 mb-1 flex items-center gap-1.5" data-id="element-185">
                  {testimonial.name}
                </h3>
                <p className="text-blue-300/80 text-sm text-center font-medium leading-tight" data-id="element-186">
                  {testimonial.highlight}
                </p>
              </div>
            </div>)}
        </div>

        {/* WhatsApp Screenshots Gallery */}
        <div className="mt-16" data-id="element-187">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-188">
            Mensajes reales de alumnos 💬
          </h3>
          <p className="text-slate-400 text-center mb-10 max-w-xl mx-auto" data-id="element-189">
            Capturas sin filtro de lo que nos escriben nuestros alumnos
          </p>

          <div className="columns-2 md:columns-3 gap-4 space-y-4" data-id="element-190">
            {[{
            src: 'https://cdn.magicpatterns.com/uploads/1cSfGFvWQ8d7X4DyEA5GEh/WhatsApp_Image_2026-03-12_at_23.58.45_(1).jpg',
            alt: 'Cesar - Primer cliente de 500 USD'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/qvCppVE6SZi571VNjezMyZ/WhatsApp_Image_2026-03-12_at_23.58.45_(2).jpg',
            alt: 'Andre - 7 mil vistas en un día'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/o4aGgMZnm3zsqdonj8kxcR/WhatsApp_Image_2026-03-12_at_23.58.45.jpg',
            alt: 'Pablo - Curso muy bueno y completo'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/9ULYyngEoET8UgpCHRDiiF/WhatsApp_Image_2026-03-12_at_23.58.44_(1).jpg',
            alt: 'Alumno - Un re cambio en mi vida'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/9ZUtSPQtoygzEgqBEcRsfR/WhatsApp_Image_2026-03-12_at_23.58.44.jpg',
            alt: 'Alumno - Creo contenido para mi emprendimiento'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/uAnPCRAJgWmcQqueMyGbar/WhatsApp_Image_2026-03-12_at_23.58.45_(3).jpg',
            alt: 'Samuel - Un antes y un después en mi vida'
          }].map((screenshot, i) => <div key={i} className="break-inside-avoid rounded-2xl overflow-hidden border border-slate-700 bg-slate-800 shadow-lg" data-id="element-191">
                <img src={screenshot.src} alt={screenshot.alt} className="w-full h-auto object-cover" loading="lazy" data-id="element-192" />
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-193">
            <Button href="https://brunocairo.com/cart/50636149457129:1" size="xl" isExternal className="w-full md:w-auto md:px-12 animate-pulse-slow" data-id="element-194">
              ¡Quiero ser el próximo caso de éxito!
            </Button>
          </div>
        </div>
      </div>
    </section>;
}